module.exports = __webpack_public_path__ + "dc84eb11a2270522ebda6dae9c3937c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/plate-colorpicker/img/metal-color-bronze.png
// module id = KaFy
// module chunks = 5